import { ReactElement } from 'react';

import { Checkbox } from '@dreryk/react-components';
import { BindingCreator } from '@dreryk/react-common';

import { calendarTranslationKeys } from '../../../../../translations';

type ScheduleOnlyVisibilityPreferenceFormBeanPart = {
   preferScheduleOnlyVisible: boolean;
};

type ScheduleOnlyVisibilityPreferenceFieldProps = {
   register: BindingCreator<ScheduleOnlyVisibilityPreferenceFormBeanPart, 'preferScheduleOnlyVisible'>;
};

export const ScheduleOnlyVisibilityPreferenceField = (
   props: ScheduleOnlyVisibilityPreferenceFieldProps
): ReactElement => {
   return (
      <Checkbox
         testId={'preferScheduleOnlyVisible'}
         controller={props.register('preferScheduleOnlyVisible')}
         label={calendarTranslationKeys.preferScheduleAndOffScheduleVisits}
      />
   );
};
